import { render, staticRenderFns } from "./TSScopeSelect.vue?vue&type=template&id=98939e52&"
import script from "./TSScopeSelect.vue?vue&type=script&lang=ts&"
export * from "./TSScopeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98939e52')) {
      api.createRecord('98939e52', component.options)
    } else {
      api.reload('98939e52', component.options)
    }
    module.hot.accept("./TSScopeSelect.vue?vue&type=template&id=98939e52&", function () {
      api.rerender('98939e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/TSScopeSelect.vue"
export default component.exports